import React from 'react'

import SubstanceFormGrease from '../../Form/Grease'

const SubstanceContainerGrease = () => <SubstanceFormGrease />

export default SubstanceContainerGrease
